module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_03@2x-d765f6ec0533052bb4fcffc18881faf6.webp";